// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mce--disabled {\n  position: relative;\n  background-color: #f1f2f5;\n}\n.mce--disabled .mce__overlay--disabled {\n  position: absolute;\n  background-color: #f1f2f5;\n  opacity: 0.4;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n.textarea-editor fieldset {\n  border-color: #ddd;\n}\n", ""]);
// Exports
module.exports = exports;
